import { render, staticRenderFns } from "./homez.vue?vue&type=template&id=01fbe780&scoped=true&"
import script from "./homez.vue?vue&type=script&lang=js&"
export * from "./homez.vue?vue&type=script&lang=js&"
import style0 from "./homez.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./homez.vue?vue&type=style&index=1&id=01fbe780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fbe780",
  null
  
)

export default component.exports